export default __webpack_public_path__ + "static/media/graphicscard.63e7edc1.jpg";